import { render } from "./UserProfile.vue?vue&type=template&id=6f7a5884&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=6f7a5884&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f7a5884"

export default script